module.exports = __webpack_public_path__ + "static/img/ZRS4266_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ZRS4266_1.png
// module id = MUMu
// module chunks = 0